"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requiredIndicator = void 0;

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var requiredIndicator = function requiredIndicator(isRequired) {
  return !isRequired ? ' (optional)' : '';
};

exports.requiredIndicator = requiredIndicator;